/** 
 * mapserver数据查询接口axios实现
*/
import req from "../util/request";
import getPath from "../paths";

const _DATA_SERVICE = getPath("_DATA_SERVICE");
const _POI_SERVICE = getPath("_POI_SERVICE");
const _AGGREGATE_SERVICE = getPath("_AGGREGATE_SERVICE");
const format = "json";

export default class Query {
    constructor() {
    }

    _SERVICE_PROPERTYQUERY = "propertyQuery";
    _SERVICE_SPATIALQUERY = "spatialQuery";

    /**
        * 属性查询
        *
        * @param lryId
        *            图层id
        * @param whereCause
        *            过滤条件
        * @param onSuccess
        *            成功回调
        * @param onError
        *            失败回调
        * @param geoType
        *            返回空间数据类型 polygon | point
        * @function 属性查询
        */
    propertyQuery(lryId, whereCause, fields, geoType = 'polygon',
        page, rows) {
        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            fields,
            method: this._SERVICE_PROPERTYQUERY,
            userid: 1,
            wherecause: encodeURIComponent(whereCause),
            resultgeotype: geoType,
            page: page ? page : 0,
            rows: rows ? rows : 50000
        };
        return req.jsonp(url, data);
    };

    /**
     * 非空间属性查询
     *
     * @param lryId
     *            图层id
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @param fields
     *            查询字段，以逗号分隔
     * @function 属性查询
     */
    jdbcQuery(lryId, whereCause, fields,
        isBuffer, page, rows) {
        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_PROPERTYQUERY,
            userid: 1,
            wherecause: encodeURIComponent(whereCause),
            resultgeotype: "data",
            fields: fields,
            isbuffer: isBuffer,
            page: page ? page : 1,
            rows: rows ? rows : 50000
        };
        return req.jsonp(url, data);
    };

    /**
     * 非空间属性查询
     *
     * @param lryId
     *            图层id
     * @param fk
     *            属性表外键
     * @param spatatialId
     *            空间id（不需关联传-1）
     * @param fk2
     *            空间表外键
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @param fields
     *            查询字段，以逗号分隔
     * @function 属性查询
     */
    jdbcQuery2(lryId, fk, spatatialId, fk2, whereCause, fields, page, rows, ajaxOption) {
        if (!whereCause) {
            whereCause = "1=1";
        }
        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_PROPERTYQUERY,
            userid: 1,
            wherecause: encodeURIComponent(whereCause),
            resultgeotype: "data",
            fields: fields,
            spatatialId: spatatialId,
            fk: fk,
            fk2: fk2,
            page: page ? page : 1,
            rows: rows ? rows : 50000
        };
        return req.jsonp(url, data);
    };

    /**
     * 属性查询
     *
     * @param lryId
     *            图层id
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @param geoType
     *            返回空间数据类型 polygon | point
     * @function 属性查询
     */
    propertyQueryByCity(lryId, divitionId, city, whereCause,
        userid, geoType, page, rows) {
        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_PROPERTYQUERY,
            userid: userid || -1,
            city: city || "全国",
            divition: divitionId,
            wherecause: encodeURIComponent(whereCause),
            resultgeotype: geoType || 'polygon',
            page: page ? page : 0,
            rows: rows ? rows : 500000
        };
        return req.jsonp(url, data);
    };

    /**
     * 关联查询
     *
     * @param source
     *            空间图层id
     * @param target
     *             数据图层id
     * @param whereCause1
     *            空间过滤条件
     * @param whereCause2
     *            屬性过滤条件
     * @param onSuccess
     *            回调
     * @param onError
     *            返回空间数据类型 polygon | point
     * @param {Number} page
     *            分页数
     * @param {Number} rows
     *            每页数
     * @function 属性查询
     */
    joinQuery(source, target, whereCause1, whereCause2,
        page, rows) {
        let url = _DATA_SERVICE + "/999.json";
        let data = {
            method: "joinQuery",
            source: source,
            target: target,
            wherecause1: whereCause1,
            wherecause2: whereCause2,
            resultgeotype: "polygon",
            page: page ? page : 0,
            rows: rows ? rows : 100000
        };
        return req.jsonp(url, data);
    }

    /**
     * 空间查询
     *
     * @param lryId
     *            图层id
     * @param strGeo
     *            113.752 38.2434,114.148 38.1695,114.048 37.8354,113.653
     *            37.9091,113.752 38.2434
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @param onError
     *            错误回调
     * @param geoType
     *            返回空间数据类型 (polygon | point)
     * @param wktype
     *            geometry格式（full | null）
     * @function 空间查询
     */
    spatialQuery(lryId, strGeo, whereCause,
        geoType, page, rows, method, wktype = "full") {
        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_SPATIALQUERY,
            userid: 1,
            geo: strGeo,
            page: page ? page : 0,
            rows: rows ? rows : 50000,
            wherecause: encodeURIComponent(whereCause),// whereCause
            resultgeotype: geoType === null || geoType === undefined ? 'polygon' : 'point',
            wktype: wktype ? wktype : null
        };
        if (!method || method === "jsonp") {
            return req.jsonp(url, data);
        } else if (method === "post") {
            return req.post(url, data);
        }
    };

    /**
     * 两级空间查询
     *
     * @param lryId
     *            图层id
     * @param cluseId
     *            首次分析的图层id
     * @param cluseFields
     *            首次分析的图层要加入的字段
     * @param strGeo
     *            113.752 38.2434,114.148 38.1695,114.048 37.8354,113.653
     *            37.9091,113.752 38.2434
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @param onError
     *            错误回调
     * @param geoType
     *            返回空间数据类型 (polygon | point)
     * @function 空间查询
     */
    twoSpatialQuery(lryId, cluseId, cluseWhereCause, cluseFields,
        strGeo, whereCause, geoType, page, rows, method, wktype) {

        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_SPATIALQUERY,
            cluseId: cluseId,
            cluseFields: encodeURIComponent(cluseFields),
            userid: 1,
            cluseWhereCause: encodeURIComponent(cluseWhereCause),
            geo: strGeo,
            page: page ? page : 0,
            rows: rows ? rows : 50000,
            wherecause: encodeURIComponent(whereCause),// whereCause
            resultgeotype: geoType === null || geoType === undefined ? 'polygon' : 'point',
            wktype: wktype ? wktype : null
        };
        if (!method || method === "jsonp") {
            return req.jsonp(url, data);
        } else if (method === "post") {
            return req.post(url, data);
        }
    };

    /**
     * 两级空间查询
     *
     * @param lryId
     *            图层id
     * @param cluseId
     *            首次分析的图层id
     * @param divition
     *            行政区划图层id
     * @param lryId
     *            图层id
     * @param strCity
     *            当前城市名
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @param onError
     *            错误回调
     * @param geoType
     *            返回空间数据类型 (polygon | point)
     * @function 空间查询
     */
    twoSpatialQueryByCity(lryId, divition, cluseId,
        cluseWhereCause, cluseFields, strCity, whereCause, geoType, page, rows,
        method, wktype) {

        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_SPATIALQUERY,
            userid: 1,
            divition: divition,
            cluseId: cluseId,
            cluseFields: encodeURIComponent(cluseFields),
            cluseWhereCause: encodeURIComponent(cluseWhereCause),
            city: encodeURIComponent(strCity),
            page: page ? page : 0,
            rows: rows ? rows : 50000,
            wherecause: encodeURIComponent(whereCause),// whereCause
            resultgeotype: geoType === null || geoType === undefined ? 'polygon' : 'point',
            wktype: wktype ? wktype : null
        };
        if (!method || method === "jsonp") {
            return req.jsonp(url, data);
        } else if (method === "post") {
            return req.post(url, data);
        }
    };

    innerSpatialQuery(lryId, strGeo, whereCause, pageindex, pagesize) {
        let url = _DATA_SERVICE + "/" + lryId + "." + format;
        let data = {
            method: this._SERVICE_SPATIALQUERY,
            userid: 1,
            geo: strGeo,
            page: pageindex,
            rows: pagesize,
            wherecause: ""// whereCause
        };
        return req.jsonp(url, data);
    };

    /**
     * POI查询
     *
     * @param lryId
     *            图层id
     * @param strGeo
     *            113.752 38.2434,114.148 38.1695,114.048 37.8354,113.653
     *            37.9091,113.752 38.2434
     * @param whereCause
     *            过滤条件
     * @param onSuccess
     *            回调
     * @function POI查询
     */
    poiQuery(lryId, strGeo, whereCause) {
        let url = _POI_SERVICE + "/" + lryId + "." + format;
        let data = {
            userid: 1,
            geo: strGeo,
            wherecause: encodeURIComponent(whereCause)
        };
        return req.jsonp(url, data);
    };

    /**
     * wms查询
     *
     * @param lryId
     *            图层id
     * @param whereCause
     *            过滤条件
     * @param tolerance
     *            容差
     * @param onSuccess
     *            回调
     * @param onError
     *            失败回调
     * @param isReset
     *            是否单次查询
     * @function wms查询
     */
    wmsQuery(lryId, whereCause, tolerance,
        isReset) {
        // let pobj = this;
        // let mapHandler = (handler === null ? this.handler : handler);
        // // 1. draw
        // mapHandler.draw("point", function (e) {
        //     let geoData = e.x + " " + e.y;

        //     // 2. get buffer
        //     let a = new mv.Handle.Analysis();
        //     let distance = tolerance / 96400;
        //     a.bufferAnalysis(geoData, distance, function (strGeo) {
        //         strGeo = strGeo.substring(strGeo.lastIndexOf('((') + 2, strGeo.length - 2);

        //         // 3. spatial query
        //         pobj.spatialQuery(lryId, strGeo, whereCause, null);
        //     }, onError);
        // }, isReset, false);
    };

    /**
     * wms查询(多图层查询)
     *
     * @param tolerance
     *            容差
     * @param onSuccess
     *            回调
     * @param onError
     *            失败回调
     * @param isReset
     *            是否单次查询
     * @function wms查询
     */
    wmsMultiQuery(tolerance, isReset) {

    };

    /**
     * 网络地图查询
     *
     * @param poiname
     *            查询名称
     * @param region
     *            所在城市
     * @param format
     *            返回格式
     * @param onSucces
     *            回调
     * @function 网络地图查询
     */
    networkPoiQuery(poiname, region) {
        let url = _POI_SERVICE + "/-1." + format;
        let data = {
            q: poiname,
            region: region
        };
        return req.jsonp(url, data);
    };
    /**
     * 聚合查询接口
     * @param sid 服务id
     * @param {String} type 统计类型，AVG/SUM/COUNT
     * @param {String} sfields  统计字段
     * @param {String} qfields  查询/聚合字段
     * @param {String} wherecause 过滤条件
    */
    aggregateQuery(sid, type, sfields, qfields, wherecause) {
        let url = `${_AGGREGATE_SERVICE}/aggregate/${type}/${sid}`
        return req.get(url, {
            sfields: sfields,
            qfields: qfields,
            filter: wherecause
        });
    }
}